export default __webpack_public_path__ + "9c87c2e2b6f5ab7f34ec119d7bf17d11.svg";